import { z } from "zod";

export const TournamentWinnerConfigSchema = z.object({
  enabled: z.boolean(),
  points: z.number().int().min(0),
  deadlineAt: z.coerce.date().nullable().optional(),
  deadlineMinutesBeforeFirstMatch: z.number().int().min(0).optional(),
});
export type TournamentWinnerConfigDTO = z.infer<typeof TournamentWinnerConfigSchema>;

export const TournamentWinnerTeamOptionSchema = z.object({
  participantId: z.string(),
  teamId: z.string().nullable(),
  name: z.string(),
  logo: z.string().nullable(),
});
export type TournamentWinnerTeamOptionDTO = z.infer<typeof TournamentWinnerTeamOptionSchema>;

export const TournamentWinnerSetupResponseSchema = z.object({
  enabled: z.boolean(),
  points: z.number(),
  deadlineAt: z.coerce.date().nullable(),
  isOpen: z.boolean(),
  teams: z.array(TournamentWinnerTeamOptionSchema),
});
export type TournamentWinnerSetupResponseDTO = z.infer<
  typeof TournamentWinnerSetupResponseSchema
>;

export const TournamentWinnerPredictionResponseSchema = z.object({
  poolId: z.string(),
  participantId: z.string(),
  predictedParticipantId: z.string(),
  teamName: z.string().nullable(),
  teamLogo: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type TournamentWinnerPredictionResponseDTO = z.infer<
  typeof TournamentWinnerPredictionResponseSchema
>;

export const UpsertTournamentWinnerPredictionRequestSchema = z.object({
  predictedParticipantId: z.string().min(1, "Selecciona un equipo"),
});
export type UpsertTournamentWinnerPredictionRequestDTO = z.infer<
  typeof UpsertTournamentWinnerPredictionRequestSchema
>;
